import React from "react";

import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import Image from "react-bootstrap/Image";

const Contact = () => {
  return (
    <Container>
      <Row className="centrado">
        <h1 className="encabezado">
          Cotiza con nosotros. <br /> Bordamos desde una pieza!
        </h1>
      </Row>
      <Row className="centrado">
        <table>
          <tr>
            <td>
              <Image
                src="./assets/images/whatsapp.png"
                width="50px"
                height="50px"
                fluid
                alt="whatsapp_icon"
              />
            </td>
            <td>
              <h3 className="encabezado">477-115-69-77 / 477-234-53-64</h3>
            </td>
          </tr>
          <tr>
            <td>
              <Image
                src="./assets/images/email.png"
                width="50px"
                height="50px"
                fluid
                alt="whatsapp_icon"
              />
            </td>
            <td>
              <h3 className="encabezado">bordados.zarinana@gmail.com</h3>
            </td>
          </tr>
        </table>
      </Row>
    </Container>
  );
};

export default Contact;
